import { get } from '@kit/utils/APIV1.js'

export const bySlug = async(slug) => {
  return get(`team/${slug}/long`)
}
export const all = async(short) => {
  return get(`teams/all/${short ? 'short' : 'long' }`)
}